import { useEffect, useState } from 'react';

const DEFAULT_DELAY = 1000;

/**
 * @description Debounce edilmiş değeri döndüren özel bir React Hook'u
 * @param {string} value Debounce edilmek istenen değer
 * @param {number} delay Debounce süresi (milisaniye cinsinden)
 * @returns {string} Debounce edilmiş değer
 * @example
 * const debouncedSearchTerm = useDebouncedValue(searchTerm);
 */
function useDebouncedValue(value, delay = DEFAULT_DELAY) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timeout);
  }, [value, delay]);

  return debouncedValue;
}

export default useDebouncedValue;
